module.exports = __webpack_public_path__ + "static/img/stripe-logo.5be80ee9.svg";